import { FC, useEffect, useRef } from "react";
import { EditorState } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { rqlHighlighting, rqlLanguage } from "../utils/rqlLanguage";

// A read-only CodeMirror view — same keyword/string syntax highlighting (rqlLanguage.ts) as the
// real Equation Editor, just non-editable, for showing a formatted equation as plain reference
// text (the Dry Run modal's "view formatted equation" popup).
const ReadOnlyEquationView: FC<{ value: string }> = ({ value }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    const view = new EditorView({
      state: EditorState.create({
        doc: value,
        extensions: [rqlLanguage, rqlHighlighting, EditorView.lineWrapping, EditorView.editable.of(false)],
      }),
      parent: containerRef.current,
    });
    return () => {
      view.destroy();
    };
  }, [value]);

  return <div className="dryRunFormattedCodeView" ref={containerRef} />;
};

export default ReadOnlyEquationView;
